'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _SliderSwatches = require('./SliderSwatches');

var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);

var _SliderPointer = require('./SliderPointer');

var _SliderPointer2 = _interopRequireDefault(_SliderPointer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Slider = exports.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = (0, _reactcss2["default"])((0, _merge2["default"])({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return _react2["default"].createElement('div', {
    style: styles.wrap || {},
    className: 'slider-picker ' + className
  }, _react2["default"].createElement('div', {
    style: styles.hue
  }, _react2["default"].createElement(_common.Hue, {
    style: styles.Hue,
    hsl: hsl,
    pointer: pointer,
    onChange: onChange
  })), _react2["default"].createElement('div', {
    style: styles.swatches
  }, _react2["default"].createElement(_SliderSwatches2["default"], {
    hsl: hsl,
    onClick: onChange
  })));
};

Slider.propTypes = {
  styles: _propTypes2["default"].object
};
Slider.defaultProps = {
  pointer: _SliderPointer2["default"],
  styles: {}
};
exports["default"] = (0, _common.ColorWrap)(Slider);